import api from './api';

export interface Policy {
  id: string;
  title: string;
  content: string;
  type: string;
  documentUrl?: string;
  isActive: boolean;
  requireAcceptance: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PolicyStatus {
  unacceptedPolicies: Policy[];
  hasAcceptedAll: boolean;
}

export const policiesService = {
  async getAll(): Promise<Policy[]> {
    const response = await api.get('/policies');
    return response.data;
  },

  async getActive(): Promise<Policy[]> {
    const response = await api.get('/policies/active');
    return response.data;
  },

  async getUserStatus(): Promise<PolicyStatus> {
    const response = await api.get('/policies/user-status');
    return response.data;
  },

  async acceptPolicy(policyId: string): Promise<void> {
    await api.post(`/policies/accept/${policyId}`);
  },

  async create(data: {
    title: string;
    content: string;
    type?: string;
    requireAcceptance?: boolean;
  }): Promise<Policy> {
    const response = await api.post('/policies', data);
    return response.data;
  },

  async update(id: string, data: Partial<Policy>): Promise<Policy> {
    const response = await api.put(`/policies/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/policies/${id}`);
  },

  async uploadDocument(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/policies/upload', formData);
    return response.data;
  },
};

